import * as gamesAPI from "modules/gamesAPI"
import { useAsync } from "react-use"
import Loader from "../components/Loader"
import PageDefaultLayout from "../components/PageDefaultLayout"
import PageTabsLayout from "../components/PageTabsLayout"

const PageLoader = ({ tabId, appId }) => {
  const { loading, error, value } = useAsync(() => {
    if (appId) return gamesAPI.getRelatedFeed(appId)
    return gamesAPI.getTabFeed(tabId)
  })

  if (loading) return <Loader />
  if (error) throw error
  if (!value) return <div>No Feed Content</div>

  const { tabLayout, tabItems } = value

  if (tabLayout === "tabs")
    return <PageTabsLayout tab={value} tabItems={tabItems} />
  return <PageDefaultLayout tab={value} tabItems={tabItems} />
}

export default PageLoader
